import React, { useState, useEffect } from 'react';
import ParticipationForm from './components/ParticipationForm';
import { FormData } from './types/participation.types';
import { setupWordPressIntegration, mapFormDataToWordPress, submitFormToWordPress, notifyHeightChange } from './wordpress-integration';

const App: React.FC = () => {
  const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false);

  // ========================================
  // CONFIGURACIÓN DE INTEGRACIÓN CON WORDPRESS
  // ========================================

  // Configurar integración con WordPress
  useEffect(() => {
    try {
      const cleanup = setupWordPressIntegration();
      return cleanup;
    } catch (error) {
      console.error('Error setting up WordPress integration:', error);
    }
  }, []);

  // Notificar altura al iframe cuando aparece el mensaje de éxito (evita que quede cortado)
  useEffect(() => {
    if (!showSuccessMessage) {
      return;
    }
    try {
      const t1 = setTimeout(() => notifyHeightChange(), 100);
      const t2 = setTimeout(() => notifyHeightChange(), 350);
      const t3 = setTimeout(() => notifyHeightChange(), 700);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
        clearTimeout(t3);
      };
    } catch (error) {
      console.error('Error notifying height change:', error);
    }
  }, [showSuccessMessage]);

  const handleFormSubmit = (data: FormData) => {
    try {
      // Mapear datos al formato de WordPress y enviar
      const wordpressData = mapFormDataToWordPress(data, []);
      submitFormToWordPress(wordpressData, 'new');
      
      // Mostrar mensaje de éxito
      setShowSuccessMessage(true);
      
      // Limpiar mensaje de éxito después de 5 segundos
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 5000);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const handleFormReset = () => {
    // No hay opciones de participación que limpiar
  };


  return (
    <div className={`app${showSuccessMessage ? ' app--with-success' : ''}`}>
      <ParticipationForm 
        onSubmit={handleFormSubmit} 
        onReset={handleFormReset}
        showSuccessMessage={showSuccessMessage}
      />
    </div>
  );
};

export default App;